import { configureStore, ThunkAction, Action, combineReducers } from "@reduxjs/toolkit";
import { ActionType } from "typesafe-actions";

import { COGNITO } from "config";
import { createLoggerMiddleware } from "logger";

// Import reducers
import CMRAuth from "state/CMRAuth";
import RightDrawer from "state/slices/RightDrawerSlice";
import DialogSlice from "./slices/DialogSlice";
import LoadingIndicatorSlice from "./slices/LoadingIndicatorSlice";
import SceneSlice from "state/slices/SceneSlice";
import NotificationSlice from "./slices/NotificationSlice";

const rootReducer = combineReducers({
    CMRAuth: CMRAuth.getReducer(),
    ModelWindow: RightDrawer,
    Dialog: DialogSlice,
    Loading: LoadingIndicatorSlice,
    Scene: SceneSlice,
    Notification: NotificationSlice,
});

// Define root types encapsulating the whole store, all actions, and all thunks
export type RootState = ReturnType<typeof rootReducer>;
export type AppAction = ActionType<unknown>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

// Create the store
const store = configureStore({
    reducer: rootReducer,
    // https://redux-toolkit.js.org/usage/usage-with-typescript#correct-typings-for-the-dispatch-type
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

// Link in CMR Auth to the store
CMRAuth.configure(store, COGNITO);

export type AppDispatch = typeof store.dispatch;

export default store;
